import { TipType } from './tip-type.enum';

export class Tip {
  constructor(public type: TipType, public value: number) {}
}
